import { cn } from '@/lib/cn'

export type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'outline' | 'info'

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant
}

export function Badge({ className, variant = 'default', children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-3 py-0.5 text-xs font-medium uppercase tracking-wide',
        badgeStyles[variant],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  )
}

const badgeStyles: Record<BadgeVariant, string> = {
  default: 'border-white/10 bg-white/10 text-white',
  success: 'border-success-400/30 bg-success-400/15 text-success-200',
  warning: 'border-warning-400/40 bg-warning-400/15 text-warning-200',
  danger: 'border-danger-400/40 bg-danger-400/15 text-danger-200',
  outline: 'border-white/30 text-white/80',
  info: 'border-brand-400/30 bg-brand-400/15 text-brand-100',
}
